import { NgModule } from '@angular/core';

import { ApFileUploadComponent } from './file-upload.component';

@NgModule({
    imports: [ApFileUploadComponent],
    exports: [ApFileUploadComponent]
})
export class ApFileUploadModule {}
